import React, { useEffect, useState } from 'react'
import { Doughnut } from 'react-chartjs-2'
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js';

ChartJS.register(ArcElement, Tooltip, Legend);



const PreviousAssessmentDonutChart = (props) => {

    const [curOWS, setCurOWS] = useState(props.CurrentOWSValue)
    
    const labelCenter = {
        id: "labelCenter",
        beforeDraw: function (chart) {
            var width = chart.width,
                height = chart.height,
                ctx = chart.ctx;
            ctx.restore();
            var fontSize = (height / 75).toFixed(2);
            ctx.font = fontSize + "em sans-serif";
            ctx.textBaseline = "top";
            var text = chart.config.options.beforeDrawHack,
                textX = Math.round((width - ctx.measureText(text).width) / 2),
                textY = Math.round((height - ctx.measureText(text).width) / 2);

            ctx.fillText(text, textX, textY);
            ctx.save();
        }
    };
    const graphcolors = ['#209D70', '#FEC957', '#E6323A', '#c0c0c0']

    const getColor = (ows)=>{
        const vg = ows>=70 ? 0 : ows >=40 ? 1 : 2
        return graphcolors[vg]
    }
    const data = {
        datasets: [
            {
                label: "",
                data: [curOWS, 100 - curOWS],
                backgroundColor: [
                    getColor(curOWS),
                    getColor(curOWS) + "30"
                ],
                borderColor: [
                    'rgba(255, 99, 132, 0)',
                    'rgba(54, 162, 235, 0)',
                ],
                borderWidth: 0,
            },
        ],
    }
    const options = {
        responsive: true,
        cutout: '80%',
        animation: {
            animateRotate: true,
            render: false,
        },
        events: [],
        tooltips: {
            enabled: false
        },
        beforeDrawHack:curOWS,
        plugins: {
            legend: {
                display: false
            },
            labelCenter: {
                labels: [
                    {
                        text: curOWS,
                        font: {
                            size: 3.25,
                            unit: "rem",
                            color: 'black',
                            style: "bold"
                        }
                    }
                ]
            }

        }
    }
    const plugins = [labelCenter]
    return <Doughnut data={data} options={options} plugins={plugins} />
}

export default PreviousAssessmentDonutChart